import React from "react";
import { DataItem } from "../definitions/internationalTypes";
import InternationalDataCard from "./InternationalDataCard";

interface CountryDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  country: string;
  items: DataItem[];
  onViewDocument: (item: DataItem) => void;
  listType: "police" | "organization";
}

const CountryDetailModal: React.FC<CountryDetailModalProps> = ({
  isOpen,
  onClose,
  country,
  items,
  onViewDocument,
  listType,
}) => {
  if (!isOpen) return null;

  const getColorClasses = () => {
    return listType === "police"
      ? "border-primary text-primary"
      : "border-success text-success";
  };

  const getButtonClasses = () => {
    return listType === "police" ? "btn-primary" : "btn-success";
  };

  return (
    <div className="modal modal-open">
      {/* Modal */}
      <div className="modal-box w-11/12 max-w-6xl">
        {/* Header */}
        <div className={`border-b-4 ${getColorClasses()} pb-4 mb-6`}>
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-2xl font-bold text-base-content">
                {country}
              </h2>
              <p className="text-sm text-base-content/60 mt-1">
                {items.length} dokumen tersedia
              </p>
            </div>
            <button
              onClick={onClose}
              className="btn btn-sm btn-circle btn-ghost"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="max-h-96 overflow-y-auto">
          {items.length === 0 ? (
            <div className="text-center py-8">
              <svg
                className="w-12 h-12 mx-auto text-base-content/40 mb-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              <p className="text-base-content/60">Tidak ada dokumen tersedia</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-6">
              {items.map((item) => (
                <InternationalDataCard
                  key={item.id}
                  item={item}
                  onView={onViewDocument}
                />
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="modal-action">
          <button
            onClick={onClose}
            className={`btn ${getButtonClasses()} gap-x-2`}
          >
            <svg
              className="w-4 h-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            Kembali ke Daftar
          </button>
        </div>
      </div>
    </div>
  );
};

export default CountryDetailModal;
